
import { takeEvery, put, call, takeLatest } from "redux-saga/effects"

import {
    CREATE_PROVIDER,
    GET_POSTAL_CODE
} from "./actionTypes"


import {
    createProviderSuccess,
    apicreateProviderError,
    getPostalCodeSuccess,
} from "./actions"


import {
    createProviderAPI, getTypeDocumentsProviderAPI, getPostalCodeAPI
} from "../../../api/form_register_provider_api"
import { GET_TYPE_DOCUMENTS_PROVIDER } from "api/helper_path"


function* createProvider({ payload: {params, callBackSuccess}}) {
    try {
        const response = yield call(createProviderAPI, params)
        callBackSuccess()
        yield put(createProviderSuccess(response))

    } catch (error) {
        yield put(apicreateProviderError(error))
    }
}

function* getTypeDocumentsProvider({ payload: params  }) {
    try {
        const response = yield call(getTypeDocumentsProviderAPI,params)
        yield put(apicreateProviderError(response))

    } catch (error) {
        yield put(apicreateProviderError(error))
    }
}

function* getPostalCode({ payload: params  }) {
   try {
        const response = yield call(getPostalCodeAPI, params)
        const {result } = response
        yield put(getPostalCodeSuccess(result))

    } catch (error) {
        yield put(apicreateProviderError(error))
    }
   
}


function* ProviderSaga() {
    yield takeLatest(GET_TYPE_DOCUMENTS_PROVIDER, getTypeDocumentsProvider)
    yield takeEvery(GET_POSTAL_CODE, getPostalCode)
    yield takeEvery(CREATE_PROVIDER, createProvider)
}
  
export default ProviderSaga



